// extracted by mini-css-extract-plugin
export default {"nudge":"SMCoverageNudge_nudge__kAld1","icon":"SMCoverageNudge_icon__ghclS","text":"SMCoverageNudge_text__wS5+9","arrow":"SMCoverageNudge_arrow__qPaaF"};